

import {
  Component,
  OnInit,
  AfterViewInit,
  Renderer2,
  ViewEncapsulation,
  ElementRef,
  RendererStyleFlags2,
  OnDestroy
} from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
// import {AsyncLocalStorage} from 'angular-async-local-storage';
import { AppService } from './app.service';
import { RouteHistoryService } from './services/setGetRouteHistory.service';
import { ExternalLibService } from './services/set-external-lib.service';
import { SessionService } from './services/session.service';
import { GoogleAnalyticsEventsService } from './services/google-analytics-events.service';
import { ThemeService } from './services/theme.service';
import { ProfileService } from './components/profile/profile.service';
import { OrdersService } from './components/orders/orders.service';
import { PopUpService } from './modules/popup/services/popup.service';
// import { LoadScriptsPostAppComponentLoad } from './classes/load-scripts.class';
import { OnboardingBusinessType, TransactionStatusEnum, LoginBy } from './enums/enum';
import { GoogleMapsConfig } from './services/googleConfig';
import { environment } from '../environments/environment';
import { MessageType, ModalType, SIGNUP_MANDATORY_FIELDS } from './constants/constant';
import { MessageService } from './services/message.service';
import { ConfirmationService } from './modules/jw-notifications/services/confirmation.service';
import { ApiService } from './services/api.service';
import { LoaderService } from './services/loader.service';
import { merge,fromEvent ,Observable ,Observer } from 'rxjs';
import {map} from 'rxjs/operators'
import { AppCartService } from './components/catalogue/components/app-cart/app-cart.service';
import { takeWhile } from 'rxjs/operators';


declare var ga: Function;
declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  alive: boolean=true;
  currentRoute: string;
  modalType = ModalType;
  event: any;
  showCustomerVerificationPopUp: boolean;
  data: any;
  messageListener: Function;
  private unlistener: Function;
  isPlatformServer: boolean;
  imageUrl: any;
  showModalMainPopup:boolean;
  isInternerConnectionAvailable: boolean = true;
  isnewhybridapp = false;
  showShimmerData: boolean = true;
  private loginFrom = '';
  constructor(
    public appService: AppService,
    //  protected storage: AsyncLocalStorage,
    private router: Router,
    private routeHistoryService: RouteHistoryService,
    protected popup: PopUpService,
    private extService: ExternalLibService,
    public sessionService: SessionService,
    private orderService: OrdersService,
    public googleAnalyticsEventsService: GoogleAnalyticsEventsService,
    private renderer: Renderer2,
    private themeService: ThemeService,
    public profileService: ProfileService,
    public messageService: MessageService,
    private el: ElementRef,
    private googleMapsConfig: GoogleMapsConfig,
    private route: ActivatedRoute,
    public confirmationService: ConfirmationService,
    private apiService: ApiService,
    public loader:LoaderService,
    private location: Location,
    public cartService: AppCartService,
    ) { 
      this.route.queryParams.subscribe(
        (data) => {
          if (data && data.payment_done) {
          this.checkQueryParam();
          }
        });
      
    }

  private subscribeToRouterEvents(router: Router) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        document.getElementById('splashLoader').style.display = 'none';
        if(this.isnewhybridapp)
        {
          this.addLoader();
        }
        (<any>window).scrollTo(0, 0);
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
        this.routeHistoryService.setHistory(event.urlAfterRedirects);
        const newRoute = event.urlAfterRedirects || '/';
        if (newRoute !== this.currentRoute) {
          try {
            ga('send', 'pageview', newRoute);
            if (this.data.google_analytics_is_active) {
              this.googleAnalyticsEventsService.setUserId();
              ga('yeloClientTracker.send', 'pageview', newRoute, { sessionControl: 'start' });
            }
          } catch (e) {
          } finally {
            this.currentRoute = newRoute;
          }
        }
      }
    });
  }

  ngOnInit() {
  
    this.isPlatformServer = this.sessionService.isPlatformServer();
    this.isnewhybridapp = this.sessionService.ismobiledevice();
    this.sessionService.set('bId', 0);
    this.setThemeColor();
    if (!this.sessionService.getString("ip_address")) {
      try {
        this.appService.getAlternateIP().subscribe(res => {
          this.sessionService.setString('ip_address', res.ip);
        }, err => { })
      } catch (e) { }
    }
    if (this.sessionService.get('config')) {
      this.data = this.sessionService.get('config');
      
    const path = this.location.path() || '';
    const pathname = this.isPlatformServer ? '' : window.location.pathname;
    
    const normalizedPath = pathname || path;
    const language = this.sessionService.getString('language') || '';
    const languageHomePath = language ? `/${language}` : '';
    const isHome = normalizedPath === '' || normalizedPath === '/' || (languageHomePath && (normalizedPath === languageHomePath || normalizedPath === `${languageHomePath}/`));
    const isListRoute = normalizedPath.includes('/list') && this.data.default_route_id == 2;
    const isStoreRoute = normalizedPath.includes('/store') && this.data.default_route_id == 3;

    if (
      this.data?.is_popup_enabled == 1 &&
      this.data?.popup_image_url &&
      (isHome || isListRoute || isStoreRoute)
    ) {
      this.appService.showMainPopup = true;
      this.imageUrl = this.data.popup_redirect_link;
    }
    }
    if (!this.isPlatformServer) {
      this.eventForWebappLoaded();
      this.subscribeToRouterEvents(this.router);
    }
    // load hippo script
    if (!this.isPlatformServer) {
      if (
        this.sessionService.get('config') &&
        this.sessionService.get('config').is_fugu_chat_enabled
      ) {
        setTimeout(_ => {
          this.extService.initFuguWidget();
        }, 5000);
      }


    }
    
    this.appService.hitLanguageStrings();

    if (!this.isPlatformServer && this.sessionService.get('config')) {
      this.getCountryData();
    }
    this.route.queryParams.subscribe((data) => {
      if (data.access_token_web && data.vendor_id_web) {
        const obj = {
          access_token: data.access_token_web,
          vendor_id: data.vendor_id_web
        }
        if (!this.isPlatformServer) {
          // this.router.navigate(['']);
          if (!this.sessionService.get('appData')|| (this.sessionService.get('appData') && data.access_token_web &&this.sessionService.get('appData').access_token != data.access_token_web)) {
            if((this.sessionService.get('appData') && data.access_token_web && this.sessionService.get('appData').vendor_details && this.sessionService.get('appData').vendor_details.app_access_token != data.access_token_web)){
              this.messageService.loginWithDifferentAccountAccessTokenEmitter();
            }
            this.initLoginViaAccessToken(LoginBy.QUERY_PARAMS, obj);
            this.extService.socketRegister(data.vendor_id_web);
          }
          else{
            window.history.replaceState({}, document.title, window.location.pathname);
            // if(this.sessionService.get('config').bumbl_domain_name && !this.isPlatformServer)
            // (<any>window).mt('send', 'pageview',{company:this.sessionService.get('config').user_id});
          }
        }
      } else {
        if (this.sessionService.get('appData')) {
          this.initLoginViaAccessToken(LoginBy.LOCAL_STORAGE);
          this.extService.socketRegister(
            this.sessionService.get('appData').vendor_details.vendor_id
          );
        }
        else{
          // if(this.sessionService.get('config').bumbl_domain_name && !this.isPlatformServer)
          // {
          //   (<any>window).mt('send', 'pageview',{company:this.sessionService.get('config').user_id});
          // }
        }
      }
    });
    let urlParams = new URLSearchParams(window.location.search);
    if(urlParams){
      if((!this.isPlatformServer && !this.sessionService.get('appData') && urlParams.get('access_token_web') && urlParams.get('vendor_id_web'))) {
        const obj = {
          access_token: urlParams.get('access_token_web'),
          vendor_id: urlParams.get('vendor_id_web')
        }
        this.initLoginViaAccessToken(LoginBy.QUERY_PARAMS, obj);
        this.extService.socketRegister(urlParams.get('vendor_id_web'));
      }
      
      if(urlParams.get('redir_src') && urlParams.get('redir_src') == 'OPEN' && urlParams.get('payment_token') && urlParams.get('job_id')){
        let payment_token = urlParams.get('payment_token');
        let job_id = urlParams.get('job_id');
        this.router.navigate(['/open-payment'], { queryParams: { payment_token: payment_token, job_id: job_id } });
      }

      if(urlParams.get('sso_enabled')){
        this.sessionService.set('sso_enabled', urlParams.get('sso_enabled'));
      }

      if(urlParams.get('waId')){
        this.fetchWAData(urlParams.get('waId')); 
      }

      if(urlParams.get('redirected_from_whatsapp') && urlParams.get('whatsappNo')){
        this.sessionService.set('redirected_from_whatsapp', urlParams.get('redirected_from_whatsapp'));
        this.sessionService.set('whatsappNo', urlParams.get('whatsappNo'));
      }

      if(urlParams.get('hide_header_bottom')){
        this.sessionService.set('hide_header_bottom', urlParams.get('hide_header_bottom'));
      }
      
      if(urlParams.get('autoFillReferralCode') && this.sessionService.get('config').referral_code_for_signup && this.sessionService.get('config').referral_status){
        this.sessionService.set('autoFillReferralCode', urlParams.get('autoFillReferralCode'));
      }
    }



    this.messageListener = this.renderer.listen(
      'window',
      'message',
      this.onMessage.bind(this)
    );
    this.initChecks();
    this.messageService.userLoggedIn.subscribe(() => {
      this.initChecks();
    });

    if(!this.isPlatformServer)
    {
      this.updateOnlineStatus().subscribe((res: boolean) => {
        this.isInternerConnectionAvailable = res;
      });
    }
    this.unlistener = this.renderer.listen("window", "message", event => {
      if(event.data && event.data.type && event.data.type=='PopupCallback' && this.data){
       if(event.data.data && event.data.data.merchant_id  && event.data.data.slug)
       {
        let link;
        let languageSelected= this.sessionService.getString('language');
    if(event.data.data.prodname && event.data.data.pordCat)
      {  
      link= "https://" + this.data.domain_name + '/' +  languageSelected +'/store/' + event.data.data.slug + '/' +  event.data.data.merchant_id + "?prodname=" +event.data.data.prodname +"&pordCat=" +event.data.data.pordCat
        }
       else if(event.data.data.prodname)
        {
          link= "https://" + this.data.domain_name + '/' +  languageSelected +'/store/' + event.data.data.slug + '/' +  event.data.data.merchant_id + "?prodname=" +event.data.data.prodname
        }
        else{
          link= "https://" + this.data.domain_name + '/' +  languageSelected +'/store/' + event.data.data.slug + '/' +  event.data.data.merchant_id
        }
         this.openRedirectionCallback(link)
       }
      }
       });
    this.messageService.sendLocationOfLoginSignup
      .pipe(takeWhile(_ => this.alive)).subscribe(message => {
        this.loginFrom = message;
    });   
  }
   /**
   * check query param
   */
    checkQueryParam() {
 
    
        localStorage.removeItem('tipVal');
        this.messageService.clearCartOnly();
        this.sessionService.removeByChildKey('app', 'cart');
        this.sessionService.removeByChildKey('app', 'category');
        this.sessionService.removeByChildKey('app', 'checkout');
        this.sessionService.removeByChildKey('app', 'payment');
        this.sessionService.removeByChildKey('app', 'customize');
        this.sessionService.removeByChildKey('app', 'cartProduct');
        this.sessionService.removeByChildKey('app', 'checkout_template');
        this.sessionService.remove('sellerArray');
        this.sessionService.remove('tip');
        this.cartService.cartClearCall();
      
      
    }
 
  openRedirectionCallback(link)
  {
    if(this.sessionService.get('pwa_app') && this.sessionService.get("device_type_app"))
    {
      this.sessionService.openExternalLink(link)
    }else{
      window.open(link, "_blank");
    }
  }
 
 
  initChecks() {
    if (this.sessionService.get('appData') && parseInt(this.sessionService.getString('reg_status')) === 1) {
      if ((this.sessionService.get('config').is_customer_verification_required === 1) && (this.sessionService.get('appData').vendor_details.is_vendor_verified !== 1) &&
        (this.sessionService.get('config').is_customer_login_required == 1) &&
        (this.sessionService.get('config').is_vendor_verification_required === 1)
      ) {
        this.showCustomerVerificationPopUp = true;
      }
    }
  }

  // =======get country data ==========
  getCountryData() {
    this.apiService.getCountryInfo()
      .subscribe((response: any) => {
        this.sessionService.countryInfo.next(response.data)
        this.sessionService.set('current_country', response.data.country_code);
      },
        error => {
          console.error(error);
        }
      )
  }
  // =======get country data ==========

  onPopUpClose() {
    this.showCustomerVerificationPopUp = false;
    this.messageService.loginWithDiffrentAccountEmitter();
  }
  eventForWebappLoaded() {
    let dashboard_url;
    if (environment.production) {
      dashboard_url = this.sessionService.get('config').ds_domain_name ? ('https://' + this.sessionService.get('config').ds_domain_name)
        : this.sessionService.get('config').dashboard_url;
    }
    else {
      dashboard_url = 'https://dev12.yelo.red';
    }
    if (window.parent != window) {
      window.parent.postMessage({ 'type': 'domContentLoaded' }, dashboard_url);
    }
  }

  onMessage(event: Event) {
    const message = event as MessageEvent;

    if (message.data === 'map_iframe_loaded') {
      this.googleMapsConfig.isIframeLoaded = Promise.resolve(true);
    }
    const dashboard_url = this.sessionService.get('config').ds_domain_name ? ('https://' + this.sessionService.get('config').ds_domain_name)
      : this.sessionService.get('config').dashboard_url;
    const domains = [
      'https://admin.yelo.red',
      'https://admin2.yelo.red',
      'https://dev1.yelo.red',
      'https://dev7.yelo.red',
      'https://dev12.yelo.red',
      'http://localhost:4200'
    ];
    if (!domains.includes(message.origin) && message.origin != dashboard_url)
      return;

    switch (message.data.type) {
      case 'Page':
        this.themeService.config = message.data;
        this.themeService.onThemeChange();
        break;
      case 'Module':
        this.themeService.onThemeChange(message.data);
        break;
      case 'scrollToView':
        this.scrollToParticularModule(message.data);
        //<any>window.scrollTo(0, document.body.scrollHeight);
        break;
      case 'navigate':
        this.themeService.previewOn();
        this.router.navigate([message.data.route]);
        break;
    }
  }

  ngAfterViewInit() {
    if (!this.isPlatformServer) {

      if (this.sessionService.get('config') && this.sessionService.get('config').user_id == 90531) {
        this.sessionService.is_netcore_enabled = true;
      } else {
        this.sessionService.is_netcore_enabled = false;
      }
      // setTimeout(_ => {
      //   LoadScriptsPostAppComponentLoad.stripe(this._document, this.renderer, this.el);
      // }, 2000);
    }
    // LoadScriptsPostAppComponentLoad.init();
    this.paymentListener();

    // this.googleAnalyticsEventsService.checkClientGAEnable();  
  }

  private paymentListener() {
    document.addEventListener('paymentMessage', (e: any) => {
      this.initCustomOrderForQuotation(e);
    });
  }

  initCustomOrderForQuotation(e?) {
    this.sessionService.remove('orderType');
    let config = this.sessionService.get('config');
    if (config.onboarding_business_type === OnboardingBusinessType.LAUNDRY && e.detail.button_info.button_action.remaining_balance) {
      //console.error(e);
      //alert('5');
      this.sessionService.setByKey('app', 'payment', {
        amount: e.detail.button_info.button_action.remaining_balance,
        subtotal: e.detail.button_info.button_action.remaining_balance,
        is_custom_order: e.detail.button_info.button_action.is_custom_order ? e.detail.button_info.button_action.is_custom_order : undefined,
        job_id: e.detail.button_info.button_action.is_custom_order ? e.detail.button_info.button_action.job_id : undefined,
        additionalpaymentId: e.detail.button_info.button_action.is_custom_order ? e.detail.button_info.button_action.additionalpaymentId : undefined,
        order_id: e.detail.button_info.button_action.order_id,
        remaining_balance: e.detail.button_info.button_action.remaining_balance
      });
      const chekoutData = {
        amount: e.detail.button_info.button_action.remaining_balance
      };
      let payload = {
        return_enabled: 0,
        is_scheduled: 0
      };
      chekoutData['cart'] = payload;
      this.sessionService.setByKey('app', 'checkout', chekoutData);

    } else if (config.onboarding_business_type === OnboardingBusinessType.FREELANCER && e.detail.button_info.button_action.payment_for === 10) {

      this.sessionService.setByKey('app', 'payment', {
        amount: e.detail.button_info.button_action.total_amount,
        subtotal: e.detail.button_info.button_action.actual_amount,
        delivery_charge: e.detail.button_info.button_action.delivery_charge,
        order_id: e.detail.button_info.button_action.order_id,
        additional_amount: e.detail.button_info.button_action.additional_amount,
        payment_for: e.detail.button_info.button_action.payment_for,
        job_id: e.detail.button_info.button_action.job_id,
        title: e.detail.button_info.button_action.title,
        is_custom_order: e.detail.button_info.button_action.is_custom_order ? e.detail.button_info.button_action.is_custom_order : undefined,
        description: e.detail.button_info.button_action.description,
        additionalpaymentId: e.detail.button_info.button_action.additionalpaymentId
      });
      const chekoutData = {
        amount: e.detail.button_info.button_action.total_amount
      };
      let payload = {
        return_enabled: 0,
        is_scheduled: 0
      };
      chekoutData['cart'] = payload;
      this.sessionService.setByKey('app', 'checkout', chekoutData);
    }
    else {

      //console.error(e);
      //alert('4');
      this.sessionService.setByKey('app', 'payment', {
        amount: e.detail.button_info.button_action.total_amount,
        subtotal: e.detail.button_info.button_action.actual_amount,
        delivery_charge: e.detail.button_info.button_action.delivery_charge,
        order_id: e.detail.button_info.button_action.order_id,
        job_id: e.detail.button_info.button_action.is_custom_order ? e.detail.button_info.button_action.job_id : undefined,
        is_custom_order: e.detail.button_info.button_action.is_custom_order ? e.detail.button_info.button_action.is_custom_order : undefined,
        additionalpaymentId: e.detail.button_info.button_action.is_custom_order ? e.detail.button_info.button_action.additionalpaymentId : undefined,
        additional_amount: e.detail.button_info.button_action.additional_amount,
        customer_select_scheduling: e.detail.button_info.button_action.customer_select_scheduling ? e.detail.button_info.button_action.customer_select_scheduling : undefined
      });
      const chekoutData = {
        amount: e.detail.button_info.button_action.total_amount
      };
      let payload = {
        return_enabled: 0,
        is_scheduled: 0
      };
      chekoutData['cart'] = payload;
      this.sessionService.setByKey('app', 'checkout', chekoutData);
    }
    const data = {
      dual_user_key: 0,
      job_id: e.detail.button_info.button_action.order_id,
      language: 'en',
      marketplace_reference_id: this.data.marketplace_reference_id,
      marketplace_user_id: this.data.marketplace_user_id,
      reference_id: this.sessionService.get('appData').vendor_details
        .reference_id,
    };
    if (this.sessionService.get('appData')) {
      data['vendor_id'] = this.sessionService.get('appData').vendor_details.vendor_id;
      data['access_token'] = this.sessionService.get('appData').vendor_details.app_access_token;
    }
    if (config.onboarding_business_type === OnboardingBusinessType.FREELANCER && e.detail.button_info.button_action.payment_for === 10) {
      data['payment_for'] = e.detail.button_info.button_action.payment_for,
        data['additionalpaymentId'] = e.detail.button_info.button_action.additionalpaymentId,
        data['job_id'] = e.detail.button_info.button_action.job_id
    }
    if(this.sessionService.getByKey('app', 'payment').is_custom_order === 1 && this.sessionService.getByKey('app', 'payment').additionalpaymentId){
      let data = {
        vendor_id: this.sessionService.get('appData').vendor_details.vendor_id,
        job_id: this.sessionService.getByKey('app', 'payment').job_id,
        access_token: this.sessionService.get('appData').vendor_details.app_access_token,
        marketplace_user_id: this.sessionService.get('config').marketplace_user_id,
        additonal_payment_id: this.sessionService.getByKey('app', 'payment').additionalpaymentId
      }
      this.profileService.getPaymentInfo(data).subscribe(
        response => {
          try {
            let msg;
            if (response.status === 200) {
               if(response.data[0] && response.data[0].transaction_status === 2) {
                msg = 'Payment has already been completed for this order.';
                this.popup.showPopup(MessageType.ERROR, 2500, msg, false);
                this.sessionService.removeByChildKey('app', 'payment');
                return;
              }
              else if(response.data[0])
               this.orderDataDetails(data,e,response.data[0].transaction_status)
            }
            else{
              this.sessionService.removeByChildKey('app', 'payment');
              console.error(response.message);
            }
          } catch (e) {
            console.error(e);
          }
        },
        error => {
          console.error(error);
        }
      );
    }
    else{
      this.orderDataDetails(data,e,'')
    }

  }
  orderDataDetails(data,e,custm_status){
    let currentySymbol;
    if(this.sessionService.getByKey('app', 'payment').is_custom_order === 1)
      currentySymbol = e.detail.button_info.button_action.currencyObj.symbol;
    this.sessionService.remove('orderType');
    let config = this.sessionService.get('config');
    this.orderService.getOrders(data).subscribe(response => {
      if (response.status == 201 && response.message) {
        this.popup.showPopup(MessageType.ERROR, 2500, response.message, false);
        return;
      }
      if(custm_status === '' && (response.data[0].transaction_status == 2 || response.data[0].transaction_status == 1)){
        if(response.data[0].overall_transaction_status == 1 || response.data[0].overall_transaction_status == 2){
          let msg = 'Payment has already been completed for this order.';
          this.popup.showPopup(MessageType.ERROR, 2500, msg, false);
          this.sessionService.removeByChildKey('app', 'payment');
          return;
        }
      }
      if (
        !(response.data[0].transaction_status === 2 || response.data[0].transaction_status === 1) &&
        response.data[0].job_status !== 13 &&
        response.data[0].job_status !== 14 &&
        response.data[0].job_status !== 15 && custm_status == ''
      ) {
        let paymentData = this.sessionService.getByKey('app', 'payment');
        if(this.sessionService.get('config').is_multi_currency_enabled || paymentData.is_custom_order === 1){
          paymentData['custom_currency']= response.data[0].order_currency_symbol ? response.data[0].order_currency_symbol : currentySymbol;
          paymentData['user_id_merchant']= response.data[0].user_id;
          this.sessionService.setByKey('app', 'payment', paymentData);
        }

        if (paymentData && response.data[0].user_taxes) {
          paymentData['user_taxes'] = response.data[0].user_taxes;
          this.sessionService.setByKey('app', 'payment', paymentData);
        }
        //console.log(response);
        //alert('3');
        this.sessionService.set('customOrderFlow', true);
        this.router.navigate(['/payment'], {
          queryParams: { redir_source: 'CUSTOM' }
        });
        // if (screen_location == "/payment")
        // location.reload();
      }
      else if (custm_status !== 2 && response.data[0].job_status !== 13 &&
        response.data[0].job_status !== 14 && response.data[0].job_status !== 15
      ) {
        let paymentData = this.sessionService.getByKey('app', 'payment');
        if(this.sessionService.get('config').is_multi_currency_enabled || paymentData.is_custom_order === 1){
          paymentData['custom_currency']= response.data[0].order_currency_symbol ? response.data[0].order_currency_symbol : currentySymbol;
          paymentData['user_id_merchant']= response.data[0].user_id;
          this.sessionService.setByKey('app', 'payment', paymentData);
      }
        if (paymentData && response.data[0].user_taxes) {
          paymentData['user_taxes'] = response.data[0].user_taxes;
          this.sessionService.setByKey('app', 'payment', paymentData);
        }
        //console.log(response);
        //alert('3');
        this.sessionService.set('customOrderFlow', true);
        this.router.navigate(['/payment'], {
          queryParams: { redir_source: 'CUSTOM' }
        });
      }
       else {
        //console.log(response);
        //alert('2');
        let msg;
        if ((response.data[0].transaction_status === 2 || response.data[0].transaction_status === 1)) {
          if (config.onboarding_business_type === OnboardingBusinessType.LAUNDRY && e.detail.button_info.button_action.remaining_balance
            && response.data[0].overall_transaction_status === TransactionStatusEnum.PARTIAL_PAYMENT) {
            this.sessionService.set('editedOrderPayment', true);
            this.sessionService.set('customOrderFlow', true);
            this.sessionService.set('repay_merchant', response.data[0].user_id);
            if (config.merchant_select_payment_method || config.is_multi_currency_enabled) {
              this.sessionService.set('merchantPaymentMethods', response.data[0].payment_methods);
            }
            let paymentData = this.sessionService.getByKey('app', 'payment');
            if(this.sessionService.get('config').is_multi_currency_enabled || paymentData.is_custom_order === 1){
              paymentData['custom_currency']= response.data[0].order_currency_symbol ? response.data[0].order_currency_symbol : currentySymbol;
              paymentData['user_id_merchant']= response.data[0].user_id;
              this.sessionService.setByKey('app', 'payment', paymentData);
          }
            if (paymentData && response.data[0].user_taxes) {
              paymentData['user_taxes'] = response.data[0].user_taxes;
              this.sessionService.setByKey('app', 'payment', paymentData);
            }
            this.router.navigate(['/payment'], {
              queryParams: { redir_source: 'CUSTOM', is_edited_task: 1 }
            });
            // if (screen_location == "/payment")
            // location.reload();
          } else if (config.onboarding_business_type === OnboardingBusinessType.FREELANCER && e.detail.button_info.button_action.payment_for == 10) {
            this.router.navigate(['/payment'], {
              queryParams: { redir_source: 'CUSTOM' }
            });
            // if (screen_location == "/payment")
            //   location.reload();
          }
          else {
            this.sessionService.removeByChildKey('app', 'payment');
            msg = 'Payment has already been completed for this order.';
            this.popup.showPopup(MessageType.ERROR, 2500, msg, false);
          }
        } else {
          msg = 'This payment link has expired.';
          this.popup.showPopup(MessageType.ERROR, 2500, msg, false);
        }

      }
    });
  }

  

  scrollToParticularModule(data) {
    const el = document.getElementById(data.module);
    if (data.module == 'signinPopup') {
      $('#loginDialog').modal('show');
    } else {
      $('#loginDialog').modal('hide');
    }
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth' });
  }

  fetchWAData(waid){
    this.loader.show();
    let obj = {
      get_status: '1',
      session_id: waid,
      };
    this.profileService.fetchWAData(obj).subscribe((res)=>{
      this.loader.hide();
      if(res.data && res.data.user_data){
        const data = {
          waId: res.data.user_data.session_id , 
          country_code: res.data.user_data.contact_number.code, 
          name:res.data.user_data.name, 
          phone_number:res.data.user_data.contact_number.number};
        this.loginViaWA(data);
      }else{
        this.popup.showPopup(MessageType.ERROR, 2000, "No data found", false);
      }
    },
    err => {
      this.loader.hide();
      this.popup.showPopup(MessageType.ERROR, 2000, err.message, false);
    }
    )
    
  }

  loginViaWA(val) {
    this.loader.show();
    const signup_field = this.sessionService.get('config').signup_field;
    let obj = {
      'whatsapp_token': val.waId,
      'domain_name': this.sessionService.getString('domain'),
      'marketplace_reference_id': this.sessionService.get('config').marketplace_reference_id,
      'signup_field' : signup_field,
    }
    if (this.sessionService.get("device_type_app") == '1' || this.sessionService.get("device_type_app") == '4') {
      obj['device_token'] = this.sessionService.get("device_token") || this.sessionService.get("device_token_app")
    }
    this.profileService.WAlogin(obj).subscribe((response)=>{
      this.loader.hide();
      if(response.status == 200){
      this.messageService.WALogin.next({
          event: 'afterSuccess',
          response: response
      });
      }
      else if(response.status == 405 || response.status == 800){ //incase of user not registered  or data missing according to signup field status code will be 405
        let data ={
          'first_name': val.name.split(' ')[0],
          'whatsapp_token': val.waId,
          'domain_name': this.sessionService.getString('domain'),
          'marketplace_reference_id': this.sessionService.get('config').marketplace_reference_id,
          'country_code' : val.country_code,
          'phone_number' : val.phone_number,
          'email_updation' : response.data?.email_updation || 0,
        }
        if(signup_field == SIGNUP_MANDATORY_FIELDS.PHONE){
          this.registerViaWA(data);
        }
        else{
          this.messageService.getLoginSignupLocation(this.loginFrom);
          $('#loginDialog').modal('hide');
          $('#signupDialog').modal('show');
          $('.modal-backdrop').remove();
          this.messageService.openSignUpPage({
            'checkAllFields': 1,
            'response': response.data,
            'waData': data
          });
        }
      }
    },error => {
      this.loader.hide();
      this.popup.showPopup(MessageType.ERROR, 2000, error.message, false);
    })
  }

  registerViaWA(obj) {
    if (this.sessionService.get("device_type_app") == '1' || this.sessionService.get("device_type_app") == '4') {
      obj['device_token'] = this.sessionService.get("device_token") || this.sessionService.get("device_token_app")
    }
    this.loader.show();
    this.profileService.WARegister(obj).subscribe((response)=>{
      this.loader.hide();
      this.messageService.WALogin.next({
        event: 'afterSuccess',
        response: response,
        from:'register'
      });

    },error => {
      this.loader.hide();
      this.popup.showPopup(MessageType.ERROR, 2000, error.message, false);
    })
  }

  /**
   * login via access token
   */
  initLoginViaAccessToken(type: number, data?: any) {
    const obj = {
      marketplace_reference_id: this.data.marketplace_reference_id,
      marketplace_user_id: this.data.marketplace_reference_id,
    };

    // if (this.sessionService.get('appData')) {
    //   obj['vendor_id'] = this.sessionService.get('appData').vendor_details.vendor_id;
    //   obj['access_token'] = this.sessionService.get('appData').vendor_details.app_access_token;
    // }
    if (type === LoginBy.LOCAL_STORAGE) {
      if (this.sessionService.get('appData')) {
        obj['vendor_id'] = this.sessionService.get('appData').vendor_details.vendor_id;
        obj['access_token'] = this.sessionService.get('appData').vendor_details.app_access_token;
        obj['device_token']=this.sessionService.get("device_token") || this.sessionService.get("device_token_app")
      }
    } else {
      obj['vendor_id'] = data.vendor_id;
      obj['access_token'] = data.access_token;
      obj['device_token']=this.sessionService.get("device_token") || this.sessionService.get("device_token_app") 
    }
   

    this.profileService.accessTokenLogin(obj).subscribe(
      response => {
        try {
          if (response.status === 200) {
            this.sessionService.set('appData', response.data);
            // if(response.data && response.data.vendor_details && this.sessionService.get('config').bumbl_domain_name && !this.isPlatformServer){
            //   if(response.data.bumble_keys && response.data.bumble_keys.City)
            //   {
            //     (<any>window).mt('send', 'pageview', {email: response.data.vendor_details.email, firstname: response.data.vendor_details.first_name, phone: response.data.vendor_details.phone_no,company:this.sessionService.get('config').user_id,nooforders: response.data.bumble_keys && (response.data.bumble_keys.number_of_orders || response.data.bumble_keys.number_of_orders == 0) ? +response.data.bumble_keys.number_of_orders : undefined,itemincart:this.sessionService.getByKey('app', 'cart') && this.sessionService.getByKey('app', 'cart').length > 0 ? true : false,city_yelo: response.data.bumble_keys.City});     
            //   }
            //   else{
            //     (<any>window).mt('send', 'pageview', {email: response.data.vendor_details.email, firstname: response.data.vendor_details.first_name, phone: response.data.vendor_details.phone_no,company:this.sessionService.get('config').user_id,nooforders: response.data.bumble_keys && (response.data.bumble_keys.number_of_orders || response.data.bumble_keys.number_of_orders == 0) ? +response.data.bumble_keys.number_of_orders : undefined,itemincart:this.sessionService.getByKey('app', 'cart') && this.sessionService.getByKey('app', 'cart').length > 0 ? true : false});
            //   }
            // }
            if (type === LoginBy.QUERY_PARAMS) {
              this.messageService.sendLoggedIn(true);
            }
            
            if(this.sessionService.get('config').sochitel_enable) {
            this.fetchSochitelId(response.data.vendor_details);
            }
            setTimeout(_ => {
              this.extService.updateFuguWidget(true);
            }, 3000); 
            this.redirectToDebt(response.data);
          } else {
            this.router.navigate(['']);
            console.error(response.message);
          }
        } catch (e) {
          this.router.navigate(['']);
          console.error(e);
        }
      },
      error => {
        this.router.navigate(['']);
        console.error(error);
      }
    );
  }

  redirectToDebt(appData) {
    let config = this.sessionService.get('config');
    let isPayment = location.pathname.indexOf('/payment');
    let singleStoreData = window.location.pathname.split('/');
    let singleStore = singleStoreData.includes('single-store') ? true : false
    if((this.sessionService.get('info') && this.sessionService.get('info').is_single_storefront) || singleStore){
      return
    }
    if (config.is_debt_enabled && appData && appData.vendor_details && appData.vendor_details.debt_amount > 0 && (isPayment == -1) && !(config.is_guest_checkout_enabled &&  (appData && parseInt(appData.vendor_details.is_guest_account)))) {
      this.sessionService.remove('skipDebt');
      this.router.navigate(['/debtAmount']);
    }else{
      this.customerSubscription(appData)
    }
  }

  customerSubscription(appData){
    let config = this.sessionService.get('config');
    let isPayment = location.pathname.indexOf('/payment');
    if((!this.sessionService.get('customerPlanSkipperForever')) && config.is_customer_subscription_enabled && appData && parseInt(appData.vendor_details.is_customer_subscription_plan_expired) && (isPayment == -1) && !(config.is_guest_checkout_enabled && (appData && parseInt(appData.vendor_details.is_guest_account)))){
      this.sessionService.remove('customerPlanSkipped');
      this.router.navigate(['/customerSubscription/subscriptionPlan']);
    }
  }

  private setThemeColor() {
    const color = this.sessionService.get('config').color;
    this.renderer.setStyle(this.el.nativeElement, '--blue', color, RendererStyleFlags2.DashCase);
    this.renderer.setStyle(this.el.nativeElement, '--theme', color, RendererStyleFlags2.DashCase);
    this.renderer.setStyle(this.el.nativeElement,'--header_bg_color',this.sessionService.get('config').header_color, RendererStyleFlags2.DashCase);
    this.renderer.setStyle(this.el.nativeElement,'--header_font_color',this.sessionService.get('config').header_element_color, RendererStyleFlags2.DashCase);
    this.renderer.setStyle(this.el.nativeElement,'--btn-color',this.sessionService.get('config').btn_color, RendererStyleFlags2.DashCase);
    
    this.themeService.renderer = this.renderer;
    // (this.el.nativeElement as HTMLElement).style.setProperty('--blue',color);
    // (this.el.nativeElement as HTMLElement).style.setProperty('--theme',color);
  }



  ngOnDestroy() {
    this.messageListener();
    this.unlistener();
    this.alive = false;
  }
  gotoImageLink() {
    if(this.imageUrl){
      if(this.sessionService.get('pwa_app') && this.sessionService.get("device_type_app"))
      {
        this.appService.showMainPopup = false;
        this.sessionService.setString('welcome_popup_dismissed', '1');
        this.sessionService.openExternalLink(this.imageUrl)
      }else{
        this.appService.showMainPopup = false;
        this.sessionService.setString('welcome_popup_dismissed', '1');
        window.open(this.imageUrl, "_blank");
      }
    }
  }
  closeModal() {
    this.appService.showMainPopup=false
    this.sessionService.setString('welcome_popup_dismissed', '1');
  }
  hideDialog(){
    this.appService.showMainPopup = false;
    this.sessionService.setString('welcome_popup_dismissed', '1');
    this.sessionService.remove('googleToken');
    this.sessionService.remove('googleEmail');
    this.sessionService.remove('googleVendorName');
    this.sessionService.remove('googleVendorImage');
    this.sessionService.remove('fb_name');
    this.sessionService.remove('fb_id');
    this.sessionService.remove('fb_email');
  }
  fetchSochitelId(vendor_details) {
    const obj = {
      access_token: vendor_details.access_token,
      vendor_id: vendor_details.vendor_id
    }
    this.sessionService.remove("sochitelId");
    this.profileService.getSochitelId(obj).subscribe(
      (response) => {
        if (response.status == 200 && response.data.length) {
          this.sessionService.set("sochitelId", response.data[0].account_id)
        }
      },
      (error) => {
        this.popup.showPopup(MessageType.ERROR, 2000, "some error occured", false);
        console.error(error);
      })
  }
    updateOnlineStatus(){
    return merge(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      }));
    }

  addLoader(){
    this.loader.show();
    setTimeout(()=>{
      this.loader.hide();
    },500)
  }
}



